import { Produktlinie, UebergreifendItem } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../../store/appState';

export const selectProduktlinien = (state: IAppState): Array<Produktlinie> =>
  state.produkt?.produktlinien || [];

export const selectUebergreifendeLeistungen = (state: IAppState): Array<UebergreifendItem> =>
  state.produkt?.uebergreifend || [];

export const selectSelectedProduktlinie = (state: IAppState): Produktlinie =>
  state.produkt?.produktlinien?.[0];
